import { useUrlParams } from '@bpd-library/utilities';
import { ISO_CODE_GERMANY } from '@constants/countries';

const ENVIRONMENT_LOCAL = 'local';
const ENVIRONMENT_TEST = 'test';
const ENVIRONMENT_ACCEPTATION = 'acceptation';
const ENVIRONMENT_PRODUCTION = 'production';

const ENVIRONMENT_DEFAULT = ENVIRONMENT_LOCAL;

/**
 * Simple Object to check settings of the current environment
 */
class Environment {
    private _baseApiUrl: string;

    get get() {
        return window.__ENVIRONMENT_DETAILS__.environment || ENVIRONMENT_DEFAULT;
    }

    get isLocal() {
        return this.get === ENVIRONMENT_LOCAL;
    }

    get isTest() {
        return this.get === ENVIRONMENT_TEST;
    }

    get isAcceptation() {
        return this.get === ENVIRONMENT_ACCEPTATION;
    }

    get isProduction() {
        return this.get === ENVIRONMENT_PRODUCTION;
    }

    get isDebugMode() {
        return !!useUrlParams().get('debug') && !this.isProduction;
    }

    get isGermany() {
        return window.__ENVIRONMENT_DETAILS__.languageIsoCode === ISO_CODE_GERMANY;
    }

    set baseApiUrl(url: string) {
        if (!environment.isLocal) return;
        this._baseApiUrl = url;
    }

    get baseApiUrl() {
        if (!environment.isLocal) return window.location.origin;
        return this._baseApiUrl;
    }
}

const environment = new Environment();

export default environment;
